!function ($) {

    let DjangoFormset = function (element, options) {
        // expose public method
        this.destroy = DjangoFormset.prototype.destroy;
        this.refresh = DjangoFormset.prototype.refresh;

        this.init(element, options)
    }

    DjangoFormset.prototype = {

        constructor: DjangoFormset,
        createDeleteButtonForRow: function(row){
            let deleteButton = $(`<button type="button" class="${this.options?.deleteButtonCssClass ?? ''}">${this.options?.deleteButtonText ?? ''}</button>`)
            row.find(this.options.deleteButtonContainer).append(deleteButton)
            let that = this;
            row.find(`${this.options.deleteButtonContainer} button`).on("click", function () {
                that.removeForm(row)
            })
        },
        addForm: function () {
            if (!this.hasMaxForms()) {
                let newIndex = this.getTotalFormCount();
                this.setTotalFormCount(newIndex + 1);

                let newFormHtml = this.$emptyForm.html()
                    .replace(new RegExp('__prefix__', 'g'), newIndex);
                newFormHtml = $(`<div class="${this.options?.form ?? ''}">${newFormHtml}</div>`)
                let row = $(`<div class="${this.options?.form ?? ''}">${newFormHtml.html()}</div>`)
                this.$body.append(row);
                this.createDeleteButtonForRow(row)
                this.options.addRow && this.options.addRow(row)
            }
        },
        getForms: function () {
            return this.$body.find(`.${this.options.form}`)
        },


        updateElementIndex: function (elem, prefix, ndx) {
            let idRegex = new RegExp('(' + prefix + '-\\d+-)'),
                replacement = prefix + '-' + ndx + '-';

            elem.get(0).getAttributeNames().filter((k) => k !== "class").map((k) => {
                if (elem.attr(k)) elem.attr(k, elem.attr(k).replace(idRegex, replacement));
            })
        },
        removeForm: function (row) {
            let newIndex = this.getTotalFormCount();
            row.remove()
            this.setTotalFormCount(newIndex - 1)
            let forms = this.getForms()
            let that = this
            for (let i = 0; i < this.getTotalFormCount(); i++) {
                forms.eq(i).find('input,select,textarea,label,div').each(function () {
                    that.updateElementIndex($(this), that.options.prefix, i);
                });
            }
            $('body').trigger('django.formset.removeBlock', {
                formset: that.$formset
            })
        },
        hasMaxForms: function () {
            return this.getTotalFormCount() >= this.getMaxForm()
        },
        getTotalFormCount: function () {
            return parseInt(this.$formset.find(`input[name="${this.options.prefix}-TOTAL_FORMS"]`).val())
        },
        setTotalFormCount: function (value) {
            this.$formset.find(`input[name="${this.options.prefix}-TOTAL_FORMS"]`).val(value)
        },
        getMaxForm: function () {
            return parseInt(this.$formset.find(`input[name="${this.options.prefix}-MAX_NUM_FORMS"]`).val())
        },
        init: function (element, options) {
            this.$formset = element
            this.options = this.getOptions(options)
            this.$emptyForm = this.$formset.find(this.options?.emptyForm)
            this.$body = this.$formset.find(this.options?.body)
            this.prefix = this.options.prefix
            this.createAddButton()
            this.updateCurrentForms()

            this.setTotalFormCount(this.getForms().length)
        },
        updateCurrentForms: function(){
            let that = this
            this.getForms().each(function(index, elt){
                $(elt).find('input').each(function(i, e){
                    e.getAttributeNames().filter((k) => k !== "class").map((k) => {
                        if ($(e).attr(k)) $(e).attr(k, $(e).attr(k).replace('__prefix__', index));
                    })
                })
                that.createDeleteButtonForRow($(this))
            })
            this.options?.afterUpdate && this.options?.afterUpdate()
        },
        getOptions: function (options) {
            options = $.extend({}, $.fn.djangoFormset.defaults, options, this.$formset.data())
            return options
        },
        destroy: function () {

        },
        createAddButton: function () {
            this.$addButton = $(`<button type="button" class="${this.options?.addButtonCssClass ?? ''}">${this.options?.addButtonText ?? ''}</button>`)
            this.$addButton.appendTo(this.$formset)
            let that = this;
            this.$addButton.on('click', function () {
                that.addForm()
            })
        },
        refresh: function () {
            this.destroy();
        }
    }

    /* DJANGO FORMSET PLUGIN DEFINITION
  * ========================= */

    let old = $.fn.djangoFormset

    $.fn.djangoFormset = function (option) {
        return this.each(function () {
            let $this = $(this)
            let data = $this.data('django-formset')
            let options = typeof option == 'object' && option
            if (!data) {
                $this.data('djangoFormset', (data = new DjangoFormset($this, options)))
            }
            // eslint-disable-next-line security/detect-object-injection
            if (typeof option == 'string') data[option]()
        })
    }

    $.fn.djangoFormset.Constructor = DjangoFormset

    $.fn.djangoFormset.defaults = {
        emptyForm: '.empty-formset',
        form: 'form-row',
        addButtonText: 'Add more',
        addButtonCssClass: '',
        body: '.formset-body',
        prefix: '',
        addRow: null,
        deleteButtonCssClass: '',
        deleteButtonText: '',
        deleteButtonContainer: '.remove-btn-container'
    }


    /* CMS_JSONFIELD NO CONFLICT
     * =================== */

    $.fn.djangoFormset.noConflict = function () {
        $.fn.djangoFormset = old
        return this
    }
}(window.jQuery);